import React from "react";

const SelectedVeiculosPanel = ({
  selectedVeiculos,
  selectedVeiculosCount,
  normalizeOptionValue,
}) => {
  return (
    <div
      style={{
        borderBottom: "2px solid #eee",
        marginBottom: 20,
        padding: "20px",
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>Selecionadas:</div>
      {selectedVeiculosCount === 0 ? (
        <div style={{ color: "#999" }}>Nenhuma frota selecionada</div>
      ) : (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {(selectedVeiculos || []).map((option, index) => {
            const normalized = normalizeOptionValue(option);
            const chipKey = normalized ?? `selecionado-${index}`;
            return (
              <span
                key={chipKey}
                style={{
                  padding: "4px 10px",
                  borderRadius: 16,
                  background: "#f2f4f7",
                  border: "1px solid #ddd",
                  fontSize: 13,
                }}
              >
                {option?.label}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SelectedVeiculosPanel;
